import http from './http.js';

//保存评论
export function getFarmFacialWeather(farm_id,year,day){
    return http.get(`/user/farm/get_farm_facial_weather/`+farm_id+'/'+year+'/'+day)
}

export function getFarmFacial(farm_id,area_id,year,param){
    return http.post(`/user/farm/get_farm_facial/`+farm_id+'/'+area_id+'/'+year,param)
}
